import { useModelContext } from '@app/contexts/model';
import { categoryList } from '@app/factory/categoryList';
import { flatJson } from '@app/factory/flatJson';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Button } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

type TProps = {};

export const ButtonSetTranslation: FunctionComponent<TProps> = observer(() => {
    const { translateStore } = useStorageTranslateContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();
    const { languageFileModel } = useModelContext();

    let sourceId = translateStore.mainLanguageId;
    let targetId = translateStore.targetLanguageId;
    let acceptedTargetId = confirmTranslateStore.languageToAccept;

    let setBoth = sourceId !== '' && (targetId !== '' || acceptedTargetId !== '');

    let disabled = !setBoth;

    return (
        <Button
            variant={'contained'}
            disabled={disabled}
            onClick={() => {
                if (targetId != '' && acceptedTargetId == '') {
                    languageFileModel.getLanguageFiles(sourceId, targetId).then((value) => {
                        let { list } = flatJson(value.main, value.target);
                        let newItems1 = categoryList(list, 0);
                        translateStore.gridDate.replace(list);
                        translateStore.categoryData.replace(newItems1);
                    });
                } else if (acceptedTargetId != '' && targetId == '') {
                    languageFileModel.getLanguageFiles(sourceId, acceptedTargetId).then((value) => {
                        let { list } = flatJson(value.main, confirmTranslateStore.usersTranslationTarget.get());
                        let newItems1 = categoryList(list, 0);
                        translateStore.gridDate.replace(list);
                        translateStore.categoryData.replace(newItems1);
                    });
                }
            }}>
            Load translations
        </Button>
    );
});
